module.exports = __webpack_public_path__ + "static/lapis_lazuli-60dda47b0105d4f46db2e922a1921cae.svg";